import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import { StyledLayout } from './Layout.styles';
import SideBar from '../SideBar';
import Loaders from '../Loaders';

const Layout = ({ children, showTemplate }) => {
  const location = useLocation();
  const isChatRoute = /^\/(chat|dashboard)(\/|$)/.test(location.pathname);

  return (
    <div className="wrapper">
      <StyledLayout $showlayout={showTemplate} $isChatRoute={isChatRoute}>
        <span className="overlay" />
        {showTemplate ? (
          <>
            <SideBar />
            <div className="children">
              <Suspense
                fallback={
                  <div className="view-loader-shell">
                    <Loaders viewLoader />
                  </div>
                }>
                {children}
              </Suspense>
            </div>
          </>
        ) : (
          <div className="children">{children}</div>
        )}
      </StyledLayout>
    </div>
  );
};

export default Layout;
